import httpClient from '/src/utils/httpClient';

export function updateSchedulerApiCall({ id, title, description, image, textAlign, textColor, itemBackgroundColor, itemTextColor }) {
  return httpClient.put(`api/music-blocks/${blockId}`, {
    id,
    title,
    description,
    image,
    text_align: textAlign,
    textColor: textColor,
    item_background_color: itemBackgroundColor,
    item_textColor: itemTextColor,
  });
}

export const getSchedulerDraftApiCall = (id, profileId) => {
  return httpClient.get(`/api/profiles/${profileId}/campaigns/${id}/draft`);
};
